declare var window: any;

export class AppConfigurationHelper {
  private static appConfig = window.window["AppGlobalConfigs"];

  public static Instance(): any {
    return this.appConfig;
  }
}
